import { store } from "../Redux";
import * as S from "../services";
import { T, TB } from "../Constants";

const notifications_reducer: T.ReduxFn<T.NotificationsRedux, T.NotificationsActions> = (state = [], payload) => {
    if (payload?.type === "ADD_NOTIFICATIONS") {
        const sorted_notifications = state.concat(payload.action)
            .sort((n1, n2) => TB.sortDates(n2.createdAt, n1.createdAt));
        return sorted_notifications;
    }
    else if (payload?.type === "LOGIN_SUCCESS") {
        S.getNotifications()
            .then(response => payload?.asyncDispatch?.({ type: "ADD_NOTIFICATIONS", action: response.data }))
            .catch(console.error);
        return state;
    }
    else if (payload?.type === "READ_NOTIFICATION" || payload?.type === "NOTIF_WAS_READ") {
        // The event is fired from this session, ask the socket server to update the notifications for the user's other sessions
        if (payload?.type === "READ_NOTIFICATION") payload?.asyncDispatch?.({ type: "SOCKET_EMIT", action: { event: "notif_was_read", params: payload.action } });
        // Update the state locally
        return state.map(s => s._id === payload.action ? { ...s, read: true } : s);
    }
    else if (payload?.type === "READ_ALL_NOTIFICATIONS" || payload?.type === "ALL_NOTIF_WERE_READ") {
        // The event is fired from another session. Ask the socket server to update the notifications in other tabs of the same user
        if (payload?.type === "READ_ALL_NOTIFICATIONS") payload?.asyncDispatch?.({ type: "SOCKET_EMIT", action: { event: "all_notifs_were_read", params: state.map(s => s._id) } });
        // Update the state locally
        return state.map(s => ({ ...s, read: true }));
    }
    // Delete some notifications
    else if (payload?.type === "DEL_NOTIFICATIONS") {
        const ids_to_remove: string[] = payload.action || [];
        if (state.some(n => ids_to_remove.includes(n._id))) return state.filter(n => !ids_to_remove.includes(n._id));
        else return state;
    }
    else return state;
}

export default notifications_reducer;

/** Set a notification as read */
export const READ_NOTIFICATION = (id: string) => store.then(s => s.dispatch({ type: "READ_NOTIFICATION", action: id, asyncDispatch: s.dispatch }));
/** Set all notifications as read */
export const READ_ALL_NOTIFICATIONS = () => store.then(s => s.dispatch({ type: "READ_ALL_NOTIFICATIONS", action: undefined, asyncDispatch: s.dispatch }));